export default "__VITE_ASSET__eQ4MSCPJ__"